module.exports = __webpack_public_path__ + "static/media/86.8d58d032.png";